import { ajax } from '../ajax'


//、 授课-课中问卷列表
export const reqSKInquiryList = (paramets) => ajax(`/Questionnaire/jxQuestionnaire/list`, paramets)

//、 教学问卷-通过id查询问卷试题列表
export const reqSKInquiryDetails = (paramets) => ajax(`/Questionnaire/jxQuestionnaire/getQuestionnairelist`, paramets)

//、 授课-课中问卷修改
export const reqSKInquiryEdit = (paramets) => ajax(`/Questionnaire/jxQuestionnaire/edit`, paramets,'put')




// WEBPACK FOOTER //
// ./src/api/give-course/inquiry.js